import { ref } from 'vue'

export const messageLoginEmpty = {
  message: '',
  class: '',
  errors: [],
  action: ''
}
export const messageLogin = ref(messageLoginEmpty)
export const showMessageLogin = ref(false)
